import { render, staticRenderFns } from "./DraftDisclaimer.vue?vue&type=template&id=16a68cfe"
var script = {}
import style0 from "./DraftDisclaimer.vue?vue&type=style&index=0&id=16a68cfe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports